// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function BrowserComponents_Form(Props) {
  var className = Props.className;
  var onSubmit = Props.onSubmit;
  var children = Props.children;
  var tmp = {
    onSubmit: (function ($$event) {
        return IOUtils.unsafeRunHandledAsync(Relude_Globals.$$const(onSubmit, $$event.defaultPrevented ? undefined : ($$event.preventDefault(), undefined)));
      })
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("form", tmp, children);
}

var make = BrowserComponents_Form;

exports.make = make;
/* react Not a pure module */
